import DomainEntity from '@/models/DomainEntity'

export default class StateScores extends DomainEntity {
  static get collectionName() {
    return 'statescores/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      attractivity: {},
      hr: {
        salary: 100,
        qvct: 100,
        finances: 100,
        reputation: 100,
        global: 100,
      },
    }
  }

  /** Score d'attractivité par défaut appliqué à une offre. */
  static defaultOfferScore() {
    return {
      price: 100,
      quality: 100,
      rse: 100,
      reputation: 100,
      global: 100,
    }
  }
}
